import { Component, OnInit } from '@angular/core';
import { DataPointDataType, DynamicComponentBase, IDynamicComponentConfig, ValidationRuleType } from '../../../dynamic-component';

@Component({
  selector: 'app-d-number-float-config',
  templateUrl: './d-number-float-config.component.html',
  styles: []
})
export class DConNumberFloatConfigComponent extends DynamicComponentBase {
  static KEY = 'd-con-number-float-config';

  dataType = DataPointDataType;
  ruleType = ValidationRuleType;
  rule: ValidationRuleType = this.ruleType.Limit;

  constructor() {
    super();
  }
  ngOnInit() {
    /** 数据类型设置 */
    this.config.dataType = this.dataType.Float;
  }
  configChange(config: IDynamicComponentConfig) {
    this.typeChangeConfig(config.ruleType);
  }
  typeChangeConfig(obj) {
    this.rule = obj;
  }
  /**
   *
   * @param obj 类型切换
   */
  typeChange(obj) {
    this.rule = obj;
    if (obj === this.ruleType.Limit) {
      this.config.effective = [];
    } else if (obj === this.ruleType.Effective) {
      this.config.displayLimits = undefined; // 显示上下限
      this.config.lowerLimit = undefined; // 下限
      this.config.upperLimit = undefined; // 上限
      this.config.isLimitOverrideAllowed = undefined; // 是否允许超上下限
    }
  }
}
